<template>
  <div>
    <el-table
      class="transaction-table"
      :data="transactions"
      v-loading="loading"
    >
      <el-table-column prop="from" label="From">
        <template slot-scope="scope">
          {{
            scope.row.from.includes('@')
              ? scope.row.from.match(/(\S*)@/)[1]
              : scope.row.from
          }}
        </template>
      </el-table-column>
      <el-table-column prop="to" label="To">
        <template slot-scope="scope">
          {{
            scope.row.to.includes('@')
              ? scope.row.to.match(/(\S*)@/)[1]
              : scope.row.to
          }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="Amount" />
      <el-table-column v-if="currency" prop="currency" label="Currency">
        <template slot-scope="scope">
          {{ scope.row.currency.match(/(\S*)#/)[1] }}
        </template>
      </el-table-column>
      <el-table-column prop="message" label="Message" />
      <el-table-column prop="date" label="Date">
        <template slot-scope="scope">
          <span>{{ scope.row.date | formatDateLong }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { filters as dateFilters } from '@util/date-format'

export default {
  name: 'transactions',

  props: {
    transactions: Array,
    currency: {
      type: Boolean,
      default: false
    },
    loading: Boolean
  },

  filters: {
    ...dateFilters
  }
}
</script>

<style scoped></style>
